import * as React from 'react';
import {useState} from 'react';
import {App} from "../App";
import {IntlProvider} from 'react-intl';
import messages_bg from "./textProperties/bg.json"
import {ToastContextProvider} from "./context/ToastContext";
import {DialogContextProvider} from "./context/DialogContext";
import {AxiosInterceptor} from "./AxiosInterceptor";
import {UserContextProvider} from "./context/UserContext";
import {Key, SWRConfig, SWRHook} from "swr";
import axios from "axios";
import {BrowserRouter} from "react-router-dom";
import {ProxyService} from './services/proxy-service';
import {usePreloader} from "./hooks/usePreloader";
import {PrimeReactProvider} from "primereact/api";


interface Props {
}

export const AppProxy: React.FC<Props> = (props) => {
    const messages = {'bg': messages_bg}
    const [interceptorReady, setInterceptorReady] = useState(false);
    const {setLoading} = usePreloader();

    const handleInterceptorReady = () => {
        setInterceptorReady(true);
    };

    const proxyMiddleware = (next: SWRHook) => {
        return (key: Key, fetcher: any, config: any) => {
            const extendedFetcher = (...args: any) => {
                args.push(true);
                if (key === "/requests/confirmedDropdown") {
                    const proxyService = new ProxyService();
                    return proxyService.transformRequestsDropdown(fetcher(args));
                }
                return fetcher(args);
            }

            return next(key, extendedFetcher, config);
        }
    }

    return <>
        <PrimeReactProvider value={{ripple: true}}>
            <IntlProvider locale={"bg-BG"} messages={messages.bg}>
                <ToastContextProvider>
                    <DialogContextProvider>
                        <UserContextProvider>
                            <AxiosInterceptor callback={handleInterceptorReady}>
                                <SWRConfig value={{
                                    fetcher: ([url, isSWR]) => axios(url, {data: {isSWR}}).then(response => response.data),
                                    loadingTimeout: 500,
                                    use: [proxyMiddleware]
                                }}>
                                    <BrowserRouter>
                                        {interceptorReady ? <App/> : null}
                                    </BrowserRouter>
                                </SWRConfig>
                            </AxiosInterceptor>
                        </UserContextProvider>
                    </DialogContextProvider>
                </ToastContextProvider>
            </IntlProvider>
        </PrimeReactProvider>
    </>
};
